import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

interface OwnProps extends HTMLAttributes<HTMLAnchorElement> {
  url: string;
  openInNewTab?: boolean;
}

const MutedLink = styled.a`
  color: ${(props) => props.theme.colors.primary};
`;

const BasicAnchor = (props: OwnProps) => {
  const { url, openInNewTab, ...restProps } = props;

  return (
    <MutedLink href={url} {...restProps}/>
  );
};

export {
  BasicAnchor,
};